import { useState } from "react"
import { FiDownloadCloud } from "react-icons/fi"
import { HiDotsHorizontal } from "react-icons/hi"
import { LuCopy, LuExpand, LuTrash2 } from "react-icons/lu"

const { Button, Dropdown } = require("components/ui")

const PostArticleOptionsButton = ({
    status,
    onToggleFullScreen,
    onDeletePostGroup,
    onExportAsHTML,
    onDuplicatePostGroup = undefined,
    forceFullScreen,
    postGroup,
    activeSocialNetwork = "",
    size = "sm"
}) => {

    const [ isLoading, setIsLoading ] = useState(false);

    return (
        <Dropdown
            placement="bottom-end"
            parentClassName={`w-full`}
            menuClass={`w-auto`}
            renderTitle={
                <Button 
                    size={size}
                    className="!rounded-xl text-tertiary-600 bg-secondary-300"
                    variant="twoTone"
                    loading={isLoading}
                    icon={<HiDotsHorizontal />}
                />
            }
        >
            {!!onDuplicatePostGroup && 
                <Dropdown.Item onClick={onDuplicatePostGroup} className="flex items-center gap-2 py-2 px-4">
                    <LuCopy className='h-6 md:text-2xl text-blue-600' />
                    <span>Duplicate post</span>
                </Dropdown.Item>
            }
            {activeSocialNetwork == "medium" && 
                <Dropdown.Item onClick={onExportAsHTML} className="flex items-center gap-2 py-2 px-4">
                    <FiDownloadCloud className='h-6 md:text-2xl text-purple-500' />
                    <span>Export as HTML</span>
                </Dropdown.Item>
            }
            {!forceFullScreen && 
                <Dropdown.Item onClick={onToggleFullScreen} className="flex items-center gap-2 py-2 px-4">
                    <LuExpand className='h-6 md:text-2xl text-primary-600' />
                    <span>Toggle full screen</span>
                </Dropdown.Item>
            }
            {status != "published" && 
                <Dropdown.Item onClick={onDeletePostGroup} className="flex items-center gap-2 py-2 px-4">
                    <LuTrash2 className='h-6 md:text-2xl text-red-600' />
                    <span>
                        {postGroup?.id 
                            ? "Delete post" 
                            : "Discard post"
                        }
                    </span>
                </Dropdown.Item>
            }
        </Dropdown>
    )
}

export default PostArticleOptionsButton;